module.exports = __webpack_public_path__ + "img/vstupenka_logo.63a20a08.svg";